module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jillian Hart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jillian Hart grew up on the original homestead where her family still lives, went to high school where "), _c('I', [_vm._v("Twin Peaks")]), _vm._v(" was filmed, earned an English degree, and has travelled extensively. When Jillian’s not writing her stories, she reads, stops for café mochas, and hikes through the pine forests near her home in Washington State.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MWbG9H/tc-custom/9781426883897.jpg?1743947437200",
      "alt": "This image is the cover for the book Heart and Soul"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heart and Soul\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("SMALL-TOWN SECRETSMichelle McKaslin felt as if a higher power had intervened when she rescued an injured stranger and gave him the job of handyman in exchange for room and board. There was just something about this tough-yet-tender drifter that made her believe she'd actually found "), _c('i', [_vm._v("the one")]), _vm._v(". Was it too much to hope that she was finally stepping out from the shadow of her four perfect sisters?Jaded undercover agent Gabe Brody had no choice but to investigate Michelle's family in a counterfeiting ring. But as he grew to see the beauty in Michelle's life, it tore him apart to deceive the wholesome woman who rejuvenated his spirit. When the truth surfaced, he would need all of the Lord's blessings to convince Michelle that he loved her, heart and soul!")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0